import script from "./productMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./productMenu.vue?vue&type=script&setup=true&lang=js"

import "./productMenu.vue?vue&type=style&index=0&id=c7270e98&lang=scss&scoped=true"

import exportComponent from "C:\\develop\\workspace_cursor\\weiquyun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7270e98"]])

export default __exports__